/**
 * c2a-continue-to-article.js file is bundled separately from 'main.js'
 * and enqueued as its own file, only on C2A template in PHP via the template-locator
 */
const { body } = document;
body.classList.add('continue-template');
body.classList.add('continue-template--truncated');

// Ensure blockInjector object exists - even for RampJS
// PrebidUI will check the displayOptions property to determine whether to render display ads.
window.s1 = window.s1 || {};
window.s1.blockInjector = window.s1.blockInjector || {};
window.s1.blockInjector.displayOptions = window.s1.blockInjector.displayOptions || {};

// const { adsScript } = window.s1?.c2aHelper?.adsScript || '';
const { s1: { c2aHelper: { adsScript = '' } = {} } = {} } = window;
// eslint-disable-next-line no-unsafe-optional-chaining
const { name: pageType = 'c2a', options: { variant = 'default' } = {} } = window.s1?.wpDataStack?.pageType['s1-page-type'];
const contentExperimentId = window.s1?.markupModifier?.content_experiment_id || '';
const inExperimentCriteria = ['EXPO1653_DUMMY', 'EXPO1653_CONTROL', 'EXPO1653_RAMPJS'];

const configureDisplayAds = () => {
  if (pageType === 'c2a-display') {
    // Disable APS and Prebid
    if (inExperimentCriteria.includes(contentExperimentId)) {
      console.log('Disabling APS');
      window.s1.blockInjector.displayOptions.omitAmazon = true;
      console.log('Disabling Prebid');
      window.s1.blockInjector.displayOptions.omitPrebid = true;
    }
  }
  // Hide display placeholders until after click/delay.
  if (['default', 'delay'].includes(variant)) {
    body.style.setProperty('--adPlaceholderDisplay', 'none');
  }
};

/**
 * injects prebid script
 * @param src
 * @return void
 */
const injectScript = (src) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = src;
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(script, firstScript);
};

/**
 * Show the initial post element nodes _before_ the "read more" button
 * @return void
 */
const showInitialPostcontent = () => {
  const c2abutton = document.querySelector('.continue-template__btn');
  let currentEl = c2abutton;

  if (c2abutton) {
    // loop through all the previous sibling elements of the c2a button
    // .continue-template__node-visible will be visible when added to those nodes
    do {
      currentEl = currentEl.previousElementSibling;
      if (currentEl) {
        currentEl.classList.add('continue-template__node-visible');
      }
    } while (currentEl);
  }
};

/**
 * show all hidden contents after the 'Read More..' button and also hide the button after
 * @return void
 */
const addButtonEventListener = () => {
  const c2abutton = document.querySelector('.continue-template__btn');
  if (c2abutton) {
    c2abutton.addEventListener('click', (e) => {
      // remove the additional c2a body class that hides the article content initially.
      // we now want to view all the normal post content and ads
      document.querySelector('body').classList.remove('unified-pagetype-c2a--hidden');

      // Worth noting that the above will only work while the button is still visible.
      // It will be hidden after the next command
      e.target.style.display = 'none';

      const hideAfterClick = document.querySelector('.continue-template__node-visible-on-truncated');
      if (hideAfterClick) {
        hideAfterClick.style.display = 'none';
      }

      // Show ad placeholders for display ads.
      if (['default', 'delay'].includes(variant)) {
        body.style.setProperty('--adPlaceholderDisplay', 'block');
      }

      // loads prebid script
      if (adsScript) {
        injectScript(adsScript);
      }
    });
  }
};

/**
 * hide post module components/sections that falls after the article content
 * @param style
 */
const hidePostModuleSections = (style = null) => {
  const postModules = document.querySelectorAll('.post-module');
  if (postModules && postModules.length > 0) {
    Array.from(postModules).forEach((postModuleElement) => {
      const postModule = postModuleElement;
      postModule.parentElement.style.display = style;
    });
  }
};

/**
 * Not all sites use all available ad units of the mobile c2a-display page template.
 * We conditionally hide the placeholders.
 */
const addDisplayAdListener = () => {
  window.addEventListener('load', () => {
    const AC = window?.s1?.AdsCoordinator || null;
    const adUnitId = 'dfp-mobile-sticky-header';
    let adUnitExists = false;

    if (AC) {
      const adUnits = Object.values(AC.getAdUnits()) || [];
      for (let i = 0; i < adUnits.length; i++) {
        const { dom: element } = adUnits[i];
        if (element.id === adUnitId) {
          adUnitExists = true;
          break;
        }
      }
    }

    // Hide mobile sticky header ad unit placeholder if no ad is loaded.
    if (!adUnitExists) {
      const el = document.getElementById(adUnitId);
      if (el) {
        el.style.display = 'none';
      }
    }
  });
};

const moveFeaturedImageBelowReadMore = () => {
  console.log('moveFeaturedImageBelowReadMore');
  const featuredImage = document.querySelector('.featured-image');
  const readMore = document.querySelector('.continue-template__btn');
  // move the featured image after the read more button
  if (readMore && featuredImage) {
    readMore.insertAdjacentElement('afterend', featuredImage);
  }
};

const continueToArticle = () => {
  // configure display ads
  configureDisplayAds();

  // show initial content
  showInitialPostcontent();

  // hide post modules from page
  hidePostModuleSections('none');

  // add click listener to read more button
  addButtonEventListener();

  // Modify display ads.
  addDisplayAdListener();

  // move featured image below read more button
  moveFeaturedImageBelowReadMore();
};

// call main function
continueToArticle();
